import React, { useId } from 'react';
import { Defs, LinearGradient, Path, Stop } from 'react-native-svg';

import { IconBase, IconProps } from './IconBase';

// $purple500 / $blue500 from variables.module.scss. Duplicated as hex the same
// way baseTheme keeps its own parallel map — SCSS variables cannot cross into
// an SVG gradient stop.
const GRADIENT_FROM = '#7D52F4';
const GRADIENT_TO = '#2970FF';

type Props = IconProps & {
  // Opt-in: the same mark also sits on a filled primary button, where a purple
  // gradient would fail against the blue. There it inherits currentColor.
  gradient?: boolean;
};

// Four-point sparkle, the conventional mark for model-generated content. The
// large star reads at 12px; the small one keeps it from looking like a plus
// sign at that size.
export const IconSparkle: React.FunctionComponent<Props> = ({
  gradient,
  ...props
}) => {
  // colons are legal in an id attribute but awkward everywhere else
  const gradientId = `sparkle-${useId().replace(/:/g, '')}`;
  const fill = gradient ? `url(#${gradientId})` : 'currentColor';

  return (
    <IconBase {...props}>
      {gradient ? (
        <Defs>
          <LinearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
            <Stop offset="0" stopColor={GRADIENT_FROM} />
            <Stop offset="1" stopColor={GRADIENT_TO} />
          </LinearGradient>
        </Defs>
      ) : null}
      <Path
        d="M9.5 2C9.5 6.1421 12.8579 9.5 17 9.5C12.8579 9.5 9.5 12.8579 9.5 17C9.5 12.8579 6.1421 9.5 2 9.5C6.1421 9.5 9.5 6.1421 9.5 2Z"
        fill={fill}
      />
      <Path
        d="M18 13C18 15.2091 19.7909 17 22 17C19.7909 17 18 18.7909 18 21C18 18.7909 16.2091 17 14 17C16.2091 17 18 15.2091 18 13Z"
        fill={fill}
      />
    </IconBase>
  );
};
